export default "__VITE_ASSET__CeZcTUOB__"